module.exports = __webpack_public_path__ + "img/comment_1_3.6e1856b8.jpg";